// ocs-proto for pages that show fingerprints whether or not this browser is linked: the linked
// device's instance, or the same module loaded once (loadProto caches it).
import { useQuery } from "@tanstack/react-query";

import { loadProto, type Proto } from "../proto/index";
import { useDevice } from "./context";

export function useProto(): Proto | undefined {
  const device = useDevice();
  const loaded = useQuery({ queryKey: ["ocs-proto"], queryFn: () => loadProto(), staleTime: Infinity, enabled: device.kind !== "linked" });
  return device.kind === "linked" ? device.proto : loaded.data;
}
